import React from "react";

/**
 * Tiny rating chip "★ 4.9 — 127 avis"
 * Used in configurator panel and other places to build social proof.
 */
export default function RatingChip({ rating = 4.9, count = 127, label, compact = false }) {
  return (
    <div className={`rating-chip${compact ? " compact" : ""}`} role="img" aria-label={`${rating} sur 5 étoiles, ${count} avis`}>
      <span className="rating-stars">{"★★★★★"}</span>
      <strong>{rating.toFixed(1)}</strong>
      <span className="rating-count">{count} {label || "avis"}</span>
    </div>
  );
}
